module.exports = "<% var notification = notificationCollection.findWhere({[property]: mod.get(\"id\")}) %>\n<div class=\"col-md-3 col-sm-3 col-xs-3 text-center\">\n    <div class=\"label <%- notification ? (notification.get(matchProperty) ? 'label-primary' : 'label-default') : 'label-default' %>\">\n        <%- notification ? (notification.get(matchProperty) ? 'Enabled' : 'Disabled') : 'Disabled' %>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/account/team/notificationDetailsList.html
// module id = 335
// module chunks = 7